import React from "react";
// Components
import LoginHeader from "../../components/login/header";
import LoginForm from "../../components/login/form";

const SignIn = () => (
  <>
    <LoginHeader />
    <LoginForm />
  </>
);

export default SignIn;
